import { combineReducers } from 'redux'
import { reducers as mindSelfReducers } from 'mindself-api-client'
import locationReducer from './location'

export const makeRootReducer = asyncReducers => {
  return combineReducers({
    location: locationReducer,
    ...mindSelfReducers,
    ...asyncReducers,
  })
}

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return

  store.asyncReducers[key] = reducer
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer



// WEBPACK FOOTER //
// ./src/store/reducers.js